const clientBaseUrl = process.env.REACT_APP_API_CLIENT_BASE_URL;
const authAPIBaseUrl = process.env.REACT_APP_API_AUTH_BASE_URL;
const userAPIBaseUrl = process.env.REACT_APP_API_USERS_BASE_URL;
const itemsAPIBaseUrl = process.env.REACT_APP_API_ITEMS_BASE_URL;
const wishAPIBaseUrl = process.env.REACT_APP_API_WISHES_BASE_URL;
const activityAPIBaseUrl = process.env.REACT_APP_API_ACTIVITY_BASE_URL;
const billingAPIBaseUrl = process.env.REACT_APP_API_BILLING_BASE_URL;
const collectionAPIBaseUrl = process.env.REACT_APP_API_COLLECTIONS_BASE_URL;
const ctasAPIBaseUrl = process.env.REACT_APP_API_CTAS_BASE_URL;
const subscriptionsAPIBaseUrl = process.env.REACT_APP_API_SUBSCRIPTIONS_BASE_URL
const socketAPIBaseUrl = process.env.REACT_APP_API_SOCKET_BASE_URL;
 export default {
  clientRoot: `${clientBaseUrl}/`,
  clientLogin: `${clientBaseUrl}/login`,
  clientLoginSSO: `${clientBaseUrl}/login-sso`,

  // auth
  getTenant: (email) => `${authAPIBaseUrl}/tenants?email=${encodeURIComponent(email.trim())}`,
  getTenantById: (tenantId) => `${authAPIBaseUrl}/tenants?tenantId=${encodeURIComponent(tenantId.trim())}`,
  googleAuthUrl: `${authAPIBaseUrl}/auth/v1/google-url`,
  registerOwner: `${authAPIBaseUrl}/owners/register`,
  resetPassword: (email) => `${authAPIBaseUrl}/reset-password?email=${encodeURIComponent(email.trim())}`,
  changeAttribute: (id) => `${authAPIBaseUrl}/tenants/${id}/profile`,
  inviteUser: `${authAPIBaseUrl}/users/invite`,
  deleteUser: (id) => `${authAPIBaseUrl}/users/${id}`,

  // subscriptions
  subscriptions:(tenantId)=> `${subscriptionsAPIBaseUrl}/${tenantId}`,
  editSubscription:(tenantId, subscriptionId)=> `${subscriptionsAPIBaseUrl}/${tenantId}/${subscriptionId}`,
  deleteSubscriptions:(tenantId)=> `${subscriptionsAPIBaseUrl}/${tenantId}`,

  // items
  items: `${itemsAPIBaseUrl}`,
  updateItem: (id) => `${itemsAPIBaseUrl}/${id}`,
  postTagToItem: (id) => `${itemsAPIBaseUrl}/${id}/tags`,
  updateTagsForBulkItems: `${itemsAPIBaseUrl}/bulk/tags`,
  deleteTagFromItem: (id, tag) => `${itemsAPIBaseUrl}/${id}/tags/${tag}`,
  updateShortener: (id) => `${itemsAPIBaseUrl}/${id}/shortener`,
  dnsCheck: `${itemsAPIBaseUrl}/shortener/dns-check`,
  getImportHistory: `${itemsAPIBaseUrl}/history`,
  updateImportHistoryStatus: `${itemsAPIBaseUrl}/history/status`,
  deleteImportHistory: importId => `${itemsAPIBaseUrl}/history/${importId}`,
  
  // wishlist
  wishes: `${wishAPIBaseUrl}/`,
  wishesList: `${wishAPIBaseUrl}/list`,
  wishUpvote: (id) => `${wishAPIBaseUrl}/${id}/upvotes`,
  wishById: (id) => `${wishAPIBaseUrl}/${id}`,
  
  // user
  updateAccountSettings: (id, listName) => `${userAPIBaseUrl}/account-settings/${id}/${listName}`,
  updateDigestOption: (id) => `${userAPIBaseUrl}/account-settings/${id}/digest`,
  updateBrandingColor: `${userAPIBaseUrl}/changeBrandingColor`,
  updateTrackers: `${userAPIBaseUrl}/updateTrackers`,
  upvoteItem: (id) => `${userAPIBaseUrl}/${id}/upvotes`,
  shareItem: (id) => `${userAPIBaseUrl}/${id}/share`,
  changeUserAttribute: (id) => `${userAPIBaseUrl}/${id}`,
  favoriteItem: (id) => `${userAPIBaseUrl}/${id}/favorites`,
  getAccountSettings: `${userAPIBaseUrl}/account-settings`,
  accountSettingsDetails: (id) => `${userAPIBaseUrl}/account-settings/${id}`,
  updateShortDomain: (id) => `${userAPIBaseUrl}/account-settings/${id}/shortDomain`,
  getUsers: `${userAPIBaseUrl}/list`,
  getUser: (id) => `${userAPIBaseUrl}/${id}`,

  // activities
  getActivities: `${activityAPIBaseUrl}/list`,
  getUserSharesForItem: (itemId) => `${activityAPIBaseUrl}/list?itemId=${itemId}`,
  testDigestNotification: `${activityAPIBaseUrl}/digest-test`,
  getAnalyticsDashboard: (startDate, endDate) => `${activityAPIBaseUrl}/analytics/dashboard?datetimeStart=${startDate}&datetimeEnd=${endDate}`,
  getAnalyticsDatatable: `${activityAPIBaseUrl}/analytics/datatable`,

  // billing
  getCustomerDetail: (customerId, tenantId) => `${billingAPIBaseUrl}/customers/${customerId}?tenantId=${tenantId}`,
  getCheckoutSession: (cId, pId, tenantId, cancelUrl, updateOnly) => `${billingAPIBaseUrl}/customers/${cId}/checkout?tenantId=${tenantId}&cancelUrl=${cancelUrl}&planId=${pId}&updateOnly=${updateOnly}`,
  updateSubscription: (cId, sId) => `${billingAPIBaseUrl}/customers/${cId}/subscriptions/${sId}`,
  getPlansList: `${billingAPIBaseUrl}/plans`,
  getInvoices: id => `${billingAPIBaseUrl}/customers/${id}/invoices`,

  // collections
  createCollection: `${collectionAPIBaseUrl}/collections`,
  deleteCollection: id => `${collectionAPIBaseUrl}/collections/${id}`,
  addItemToCollection: (itemId, collectionId) => `${collectionAPIBaseUrl}/collections/${collectionId}/items/${itemId}`,
  updateItemsOfCollection: (collectionId) => `${collectionAPIBaseUrl}/collections/${collectionId}/items`,

  createSite: `${collectionAPIBaseUrl}/sites`,
  getUserSiteContent: `${collectionAPIBaseUrl}/sitecontent`,
  deleteSite: (id) => `${collectionAPIBaseUrl}/sites/${id}`,

  // ctas
  createCta: `${ctasAPIBaseUrl}`, // just base url
  listCta: (userId) => `${ctasAPIBaseUrl}/user/${userId}`, // list CTAs by user Id
  updateCta: (id) => `${ctasAPIBaseUrl}/${id}`,

  // branding
  listBrandings: `${userAPIBaseUrl}/brandings`,
  updateBranding: (id) => `${userAPIBaseUrl}/brandings/${id}`,

  // socket
  socket: `${socketAPIBaseUrl}`
};
